module.exports = __webpack_public_path__ + "static/media/experience-doctors.0baf911d.png";